import React from "react";
import { Message } from "primereact/message";
import { COCHARGE_REVENUE_TEXTS } from "../../StationPerformance/StationPerformance.consts";
import { COPY } from "../ThgAnnualSummary.consts";

interface DataQualityNotesProps {
  excludedSessionCount: number;
  stationsWithoutOwner: number;
  /** CLR-296: rows matching `isUnpaidInternal` (stored v2 years included; internal rows with an issued credit note were paid). */
  internalStationCount: number;
}

/**
 * Energy and stations that no payout covers. Always visible when present: a reader who does not see them
 * would take the list for complete. The owner count is the backend's own, not a count of highlighted rows.
 */
const DataQualityNotes: React.FC<DataQualityNotesProps> = ({
  excludedSessionCount,
  stationsWithoutOwner,
  internalStationCount,
}) => {
  if (excludedSessionCount <= 0 && stationsWithoutOwner <= 0 && internalStationCount <= 0) return null;
  return (
    <div className="flex flex-column gap-2 mb-3">
      {stationsWithoutOwner > 0 && (
        <Message
          severity="warn"
          className="justify-content-start"
          text={COPY.stationsWithoutOwner(stationsWithoutOwner)}
        />
      )}
      {internalStationCount > 0 && (
        <Message
          severity="info"
          className="justify-content-start"
          text={COCHARGE_REVENUE_TEXTS.payoutsNote(internalStationCount)}
        />
      )}
      {excludedSessionCount > 0 && (
        <Message
          severity="info"
          className="justify-content-start"
          text={COPY.excludedSessions(excludedSessionCount)}
        />
      )}
    </div>
  );
};

export default DataQualityNotes;
